import produce from "immer";
import { bookingActions } from ".";
import { IStoreState } from "../initialStoreState";
import { initialBookingState } from "./booking.types";
import {
	CLEAR_BOOKING_STATE,
	FETCH_BOOKING_LIST_FAILED,
	FETCH_BOOKING_LIST_PROGRESS,
	FETCH_BOOKING_LIST_SUCCESS,
	FETCH_INVOICE_LIST_SUCCESS,
} from "./bookingActions";
import { LoadState } from "../../constants/enums";

export const bookingReducer = (
	state: IStoreState["booking"] = initialBookingState,
	action: bookingActions
) => {
	switch (action.type) {
		case FETCH_BOOKING_LIST_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.bookingList.loading = LoadState.InProgress;
				draftState.bookingList.list = [];
			});
			return newState;
		}
		case FETCH_BOOKING_LIST_SUCCESS: {
			const { data, totalRecords } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.bookingList.loading = LoadState.Loaded;
				draftState.bookingList.list = data;
				draftState.bookingList.totalRecords = totalRecords;
			});
			return newState;
		}
		case FETCH_BOOKING_LIST_FAILED: {
			const newState = produce(state, (draftState) => {
				draftState.bookingList.loading = LoadState.Failed;
				draftState.bookingList.list = [];
			});
			return newState;
		}

		case FETCH_INVOICE_LIST_SUCCESS: {
			const { data, totalRecords } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.invoiceList.loading = LoadState.Loaded;
				draftState.invoiceList.list = data;
				draftState.invoiceList.totalRecords = totalRecords;
			});
			return newState;
		}

		case CLEAR_BOOKING_STATE: {
			return initialBookingState;
		}
		default:
			return state;
	}
};
